import { Badge, Text } from '@radix-ui/themes';
import PropTypes from 'prop-types';

export function TechnologyBadge({ label }) {
  return (
    <Badge
      color='gray'
      size='2'
    >
      <Text
        weight='bold'
        size='1'
      >
        {label}
      </Text>
    </Badge>
  );
}

TechnologyBadge.propTypes = {
  label: PropTypes.string.isRequired,
};
